import { Injectable } from '@angular/core';
import { ReferenceDataSet, ReferenceDataSetMapSource, ReferenceDataLinkSource, ReferenceDataSetSource } from './reference-data.types';
import { tables, links } from './reference-data.static';

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataService {
  protected tablesMap: ReferenceDataSetSource = {};
  protected optionsMap: ReferenceDataSetMapSource = {};
  protected linksMap: ReferenceDataLinkSource = {};
  protected paymentFrequencyMap: ReferenceDataLinkSource = {};

  constructor() {
    this.load();
  }

  load() {
    // Get Table Maps
    for(const itemSetName in tables) {
      const isNameUpper = itemSetName.toUpperCase();
      this.tablesMap[isNameUpper] = tables[itemSetName]; 
      this.optionsMap[isNameUpper] = this.optionsMap[isNameUpper] ?? {};
      const itemSet = tables[itemSetName];
      for(const item of itemSet) {
        this.optionsMap[isNameUpper][item.code.toUpperCase()] = item;
      }
    }

    // Generate Link Sources
    for(const itemLink of links) {
      const ctUpper = itemLink.coverageCode.toUpperCase(), tableUpper = itemLink.table.toUpperCase();
      this.linksMap[ctUpper] = this.linksMap[ctUpper] ?? {};
      this.linksMap[ctUpper][tableUpper] = this.linksMap[ctUpper][tableUpper] ?? [];
      this.linksMap[ctUpper][tableUpper].push(this.optionsMap[tableUpper][itemLink.code.toUpperCase()]);
     // this.paymentFrequencyMap[ctUpper][tableUpper].push(this.optionsMap[tableUpper][itemLink.code.toLocaleLowerCase()])
    }
  }

  getReferenceDataSet(refDataSetName: string) : ReferenceDataSet | undefined {
    return this.tablesMap[refDataSetName.toUpperCase()];
  }

  getReferenceDataSetByCoverageType(coverageType: string, refDataSetName: string) : ReferenceDataSet | undefined {
    return this.linksMap[coverageType.toUpperCase()][refDataSetName.toUpperCase()];
  }

  getReferenceDataSetValue(refDataSetName: string, code: string): string {
    if(code === null) return 'Unknown';
    return this.optionsMap[refDataSetName.toUpperCase()][code.toUpperCase()]?.name;
  }

  getPaymentFrequencyValue(refDataSetName: string, code: string): string {
    if(code === null) return 'Unknown';
    return this.optionsMap[refDataSetName.toUpperCase()][code.toUpperCase()]?.name;
  }
}